module.exports = __webpack_public_path__ + "img/egoba-2.ccb0981f.png";